/**
 * Login / registration view (Feature #2). Login is required to reach any board.
 */

import { useState } from "react";

import { useRyfe } from "../RyfeContext";

import { ApiError } from "../api";

import "./ryfe.scss";

export const RyfeLogin = () => {
  const { login, register, branding } = useRyfe();
  const [mode, setMode] = useState<"login" | "register">("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      if (mode === "login") {
        await login(email, password);
      } else {
        await register(email, password);
      }
    } catch (err) {
      const msg =
        err instanceof ApiError ? err.message : "Etwas ist schiefgelaufen";
      setError(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="ryfe-auth">
      <form className="ryfe-auth__card" onSubmit={submit}>
        {/* AP-1 (P1b, Fidelity) — Mandanten-Logo neben dem Produktnamen. */}
        <h1 className="ryfe-auth__title">
          {branding.logo && (
            <img
              className="ryfe-auth__logo"
              src={branding.logo}
              alt=""
              onError={(e) => {
                (e.currentTarget as HTMLImageElement).style.display = "none";
              }}
            />
          )}
          {branding.productName}
        </h1>
        <p className="ryfe-auth__subtitle">
          {mode === "login" ? "Zum Fortfahren anmelden" : "Neues Konto anlegen"}
        </p>

        <label className="ryfe-field">
          <span>E-Mail</span>
          <input
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>

        <label className="ryfe-field">
          <span>Passwort</span>
          <input
            type="password"
            autoComplete={
              mode === "login" ? "current-password" : "new-password"
            }
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            minLength={8}
            required
          />
          {mode === "register" && (
            <span className="ryfe-auth__hint">Mindestens 8 Zeichen.</span>
          )}
        </label>

        {error && (
          <div className="ryfe-auth__error" role="alert">
            {error}
          </div>
        )}

        <button
          className="ryfe-btn ryfe-btn--primary"
          type="submit"
          disabled={busy}
        >
          {busy ? "…" : mode === "login" ? "Anmelden" : "Konto anlegen"}
        </button>

        <button
          type="button"
          className="ryfe-btn ryfe-btn--link"
          onClick={() => {
            setMode(mode === "login" ? "register" : "login");
            setError(null);
          }}
        >
          {mode === "login"
            ? "Noch kein Konto? Konto anlegen"
            : "Schon ein Konto? Anmelden"}
        </button>
      </form>
    </div>
  );
};
